
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campsite-rental/[location]/[slug]/reviews",
      function () {
        return require("private-next-pages/campsite-rental/[location]/[slug]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campsite-rental/[location]/[slug]/reviews"])
      });
    }
  